<mat-dialog-content>
  <div class="flex flex-col items-center w-full p-4">
    <p class="mb-4">{{ 'AUDIT.CONFIRM_DELETE_IMAGE' | translate }}</p>
    
    <div class="flex w-full mt-6 gap-4">
      <button
        mat-flat-button
        color="warn"
        class="flex-1 min-w-[170px] flex items-center justify-center gap-2 py-3 rounded-lg font-bold text-lg"
        (click)="deleteImage()"
      >
        <mat-icon>delete</mat-icon>
        <span class="whitespace-nowrap">{{ 'AUDIT.DELETE_IMAGE' | translate }}</span>
      </button>

      <button
        mat-stroked-button
        class="flex-1 min-w-[120px] flex items-center justify-center py-3 rounded-lg font-semibold text-lg"
        (click)="dialogRef.close()"
      >
        <span class="whitespace-nowrap">{{ 'ACTION.CLOSE' | translate }}</span>
      </button>
    </div>
  </div>
</mat-dialog-content>
